import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Protected } from "@/components/Protected";

import Landing from "@/pages/Landing";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import Forgot from "@/pages/auth/Forgot";
import Reset from "@/pages/auth/Reset";

import OwnerDashboard from "@/pages/owner/OwnerDashboard";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import StaffTerminal from "@/pages/staff/StaffTerminal";

import PublicMenu from "@/pages/customer/PublicMenu";
import OrderConfirmation from "@/pages/customer/OrderConfirmation";
import Letter from "@/pages/Letter";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<Forgot />} />
        <Route path="/reset-password" element={<Reset />} />

        <Route path="/dashboard/*" element={<Protected roles={["owner"]}><OwnerDashboard /></Protected>} />
        <Route path="/admin/*" element={<Protected roles={["super_admin"]}><AdminDashboard /></Protected>} />
        <Route path="/staff/*" element={<Protected roles={["staff"]}><StaffTerminal /></Protected>} />

        <Route path="/r/:slug" element={<PublicMenu />} />
        <Route path="/order/:orderId" element={<OrderConfirmation />} />
        <Route path="/letter" element={<Letter />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
